/* tslint:disable */
/* eslint-disable */
/**
 * Client Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BulkAssociateResourceWithClient
 */
export interface BulkAssociateResourceWithClient {
    /**
     * A URI value that typically starts with the "sharefile" schema.  Segments are delimited with a "/". Segments are composed of a leaf  type and identifier that is delimited by "-".
     * 
     * @type {string}
     * @memberof BulkAssociateResourceWithClient
     */
    clientRID: string;
    /**
     * Indicates whether to preserve previous associations when adding new ones. If true, existing associations will remain intact; if false, they may be replaced.
     * @type {boolean}
     * @memberof BulkAssociateResourceWithClient
     */
    preservePreviousAssociation?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof BulkAssociateResourceWithClient
     */
    subjectRIDs: Array<string>;
    /**
     * The permissions to be applied to the association.
     * @type {Array<string>}
     * @memberof BulkAssociateResourceWithClient
     */
    permissions: Array<string>;
    /**
     * The actorRIDs to be granted permissions on the subjectRIDs. These must be RIDs for users or groups.
     * @type {Array<string>}
     * @memberof BulkAssociateResourceWithClient
     */
    actorRIDs?: Array<string>;
    /**
     * A URI value that typically starts with the "sharefile" schema.  Segments are delimited with a "/". Segments are composed of a leaf  type and identifier that is delimited by "-".
     * 
     * @type {string}
     * @memberof BulkAssociateResourceWithClient
     */
    presetRID: string;
}

/**
 * Check if a given object implements the BulkAssociateResourceWithClient interface.
 */
export function instanceOfBulkAssociateResourceWithClient(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "clientRID" in value;
    isInstance = isInstance && "subjectRIDs" in value;
    isInstance = isInstance && "permissions" in value;
    isInstance = isInstance && "presetRID" in value;

    return isInstance;
}

export function BulkAssociateResourceWithClientFromJSON(json: any): BulkAssociateResourceWithClient {
    return BulkAssociateResourceWithClientFromJSONTyped(json, false);
}

export function BulkAssociateResourceWithClientFromJSONTyped(json: any, ignoreDiscriminator: boolean): BulkAssociateResourceWithClient {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'clientRID': json['clientRID'],
        'preservePreviousAssociation': !exists(json, 'preservePreviousAssociation') ? undefined : json['preservePreviousAssociation'],
        'subjectRIDs': json['subjectRIDs'],
        'permissions': json['permissions'],
        'actorRIDs': !exists(json, 'actorRIDs') ? undefined : json['actorRIDs'],
        'presetRID': json['presetRID'],
    };
}

export function BulkAssociateResourceWithClientToJSON(value?: BulkAssociateResourceWithClient | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'clientRID': value.clientRID,
        'preservePreviousAssociation': value.preservePreviousAssociation,
        'subjectRIDs': value.subjectRIDs,
        'permissions': value.permissions,
        'actorRIDs': value.actorRIDs,
        'presetRID': value.presetRID,
    };
}

